import React from 'react';
import './ThemePicker.css';

const OPTIONS = [
    { value: 'light', label: 'Светлое', hint: 'Для светлого зала и телефонов' },
    { value: 'dark', label: 'Тёмное', hint: 'Для проектора в затемнённом зале' },
];

/**
 * Оформление страниц для участников: голосование, результаты, экран для проектора, встроенное окно.
 * Карточки показывают маленький предпросмотр экрана в каждом варианте.
 */
function ThemePicker({ value = 'light', onChange, disabled = false, label = 'Оформление для участников', id = 'theme-picker' }) {
    return (
        <div className="theme-picker">
            <span className="theme-picker__label" id={`${id}-label`}>{label}</span>
            <div className="theme-picker__options" role="radiogroup" aria-labelledby={`${id}-label`}>
                {OPTIONS.map((o) => (
                    <button
                        key={o.value}
                        type="button"
                        role="radio"
                        aria-checked={value === o.value}
                        className={`theme-picker__option${value === o.value ? ' is-active' : ''}`}
                        onClick={() => onChange?.(o.value)}
                        disabled={disabled}
                    >
                        <span className={`theme-picker__preview theme-picker__preview--${o.value}`} aria-hidden>
                            <i className="tp-title" />
                            <i className="tp-bar" style={{ width: '78%' }} />
                            <i className="tp-bar tp-bar--2" style={{ width: '52%' }} />
                            <i className="tp-bar tp-bar--3" style={{ width: '30%' }} />
                        </span>
                        <span className="theme-picker__text">
                            <b>{o.label}</b>
                            <small>{o.hint}</small>
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
}

export default ThemePicker;
